import Cookies from 'js-cookie';

export const isNative = () => {
  try {
    const deviceCookie = Cookies.get('wh_device');
    const parsedDeviceCookie = JSON.parse(deviceCookie);
    return parsedDeviceCookie.is_native === true || parsedDeviceCookie.is_native === 'true';
  } catch (error) {
    return false;
  }
};
